import {
    WIZARD_SET_DATA,
    TRIGGER_SET_DATA,
    JUMP_FIRST_STEP,
    RESPONSABLE_LOADED,
} from '../actions';

const INIT_STATE = {
    successSubmit: false,
    triggerSubmit: { id: '', name: '' },
    jumpFirstStep: false,
    responsableLoaded: false,
};

const wizardReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case WIZARD_SET_DATA:
            return { ...state, successSubmit: action.payload };
        case TRIGGER_SET_DATA:
            return { ...state, triggerSubmit: action.payload };
        case JUMP_FIRST_STEP:
            return { ...state, jumpFirstStep: action.payload };
        case RESPONSABLE_LOADED:
            return { ...state, responsableLoaded: action.payload };
        default:
            return state;
    }
};

export default wizardReducer;
